import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-orange-50 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yeji0espmi30">
        <div className="text-center" data-id="element-22" data-mp="1aogvee7ke4bs">
          <span className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-green-950" data-id="element-23" data-mp="1apidh2mzzr30">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgir5z6ouwfq" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-25" data-mp="1eqanvz7lw20v">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qy3ossahxgxr">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-stone-200 bg-white p-6 shadow-sm ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29rjuapkmafac" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vs24c6vl4vze">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="1vu4zt6fibhbi">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-900 text-amber-400" data-id="element-30" data-mp="20qlr29i06bst">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25rsu5v97amt5" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-stone-500" data-id="element-32" data-mp="3c6ad8ynfn6sk">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-stone-600" data-id="element-33" data-mp="1h35cg1nf91zy">
                    <span className="line-through" data-id="element-34" data-mp="1c4arou5w93d7">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-amber-500 px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-green-950" data-id="element-35" data-mp="1c6exjhncscg4">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-green-950" data-id="element-36" data-mp="yc4cpbeh92fc">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-600" data-id="element-37" data-mp="tem1feczmb46">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="176sjx73m4u6s">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-stone-900" data-id="element-39" data-mp="12cekmtlty2wu">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" aria-hidden="true" data-id="element-40" data-mp="emtw7v6wqdg6" />
                        {item}
                      </li>)}
                  </ul>}

                <div className="flex-1" data-id="element-41" data-mp="59uvvl9xplgs" />
                <p className="mt-4 rounded-lg border-l-4 border-stone-500 bg-stone-100 px-4 py-3 text-sm font-semibold text-stone-700" data-id="element-42" data-mp="5awi8lwehudt">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl bg-green-900 px-6 py-6 text-center shadow-lg sm:flex-row sm:text-left" data-id="element-43" data-mp="ja5oasqw7842">
          <div data-id="element-44" data-mp="o6wdq6ol7g25">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-green-100" data-id="element-45" data-mp="o6mj25slkkq4">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 text-2xl font-extrabold text-green-100/70 line-through decoration-red-300 decoration-2" data-id="element-46" data-mp="e9hww5yr4p9b">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-47" data-mp="2z1a95o2xt6gr">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-green-100" data-id="element-48" data-mp="2yyxj0nn0zpsm">Your price today</p>
            <p className="mt-1 text-3xl font-extrabold text-amber-400" data-id="element-49" data-mp="3fa9ca6h3acw6">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-stone-700" data-id="element-50" data-mp="3aflroip7i2mv">
          Only included in this offer
        </p>
      </div>
    </section>;
}